const pagemap = new Map([
    ["Home", "MyPage/MyJobs.aspx"],
    ["CustomerList", "Admin/ManageCustomer.aspx"],
    ["ViewCustomer", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerDetails", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerHistory", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerUsers", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerJobs", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerMachines", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerContractDetails", "Admin/ManageCustomerEdit.aspx"],
    ["CustomerAccountList", "Admin/ManageCustomer.aspx"],
    ["AdminHome", "Admin/"],
    ["ImportExport", "Admin/ImportExport.aspx"],
    ["Import", "Admin/ImportExport.aspx"],
    ["Export", "Admin/ImportExport.aspx"],
    ["Documents", "Admin/ManageDocument.aspx"],
    ["NewDocument", "Admin/ManageDocumentEdit.aspx"],
    ["ViewDocument", "Admin/ManageDocumentEdit.aspx"],
    ["Departments", "Admin/ManageDepartment.aspx"],
    ["ViewDepartment", "Admin/ManageDepartmentEdit.aspx"],
    ["ViewDepartmentInfo", "Admin/ManageDepartmentEdit.aspx"],
    ["DepartmentUsers", "Admin/ManageUser.aspx"], 
    ["Settings", "Admin/ManageSetting.aspx"],
    ["SettingsHome", "Admin/ManageSetting.aspx"],
    //jobs
    ["JobAdmin", "Admin/JobStatistics.aspx"],
    ["JobsList", "Admin/JobStatistics.aspx"],
    ["JobCategories", "Admin/ManageJobCategory.aspx"],
    ["ViewJobCategory", "Admin/ManageJobCategoryEdit.aspx"],
    ["ViewJobCategoryInfo", "Admin/ManageJobCategoryEdit.aspx"],
    ["NewJobCategory", "Admin/ManageJobCategoryEdit.aspx"],
    ["JobStatuses", "Admin/ManageJobStatus.aspx"],
    //accounts
    ["Accounts", "Admin/ManageUser.aspx"],
    ["AAccounts", "Admin/ManageUser.aspx"],
    ["TAccounts", "Admin/ManageUser.aspx"],
    ["SCAccounts", "Admin/ManageUser.aspx"],
    ["PAccounts", "Admin/ManageUser.aspx"],
    ["CAccounts", "Admin/ManageUser.aspx"],
    //customer
    ["ViewCustomer", "Admin/ManageCustomer.aspx"],
    ["CustomerList", "Admin/ManageCustomer.aspx"],
    ["CustomerGroupList", "Admin/ManageCustomerGroup.aspx"],
    ["ViewCustomerGroup", "Admin/ManageCustomerGroupEdit.aspx"],
    ["ViewCustomerGroupInfo", "Admin/ManageCustomerGroupEdit.aspx"],
    //machines
    ["MachineList", "Admin/ManageMachine.aspx"],
    ["MachineInfo", "Admin/ManageMachineEdit.aspx"],
    ["MachineJobs", "Admin/ManageMachineEdit.aspx"],
    ["MachineResources", "Admin/ManageMachineEdit.aspx"],
    ["MachineLogs", "Admin/ManageMachineEdit.aspx"],
    //machine types
    ["MachineTypes", "Admin/ManageMachineType.aspx"],
    ["ViewMachineType", "Admin/ManageMachineTypeEdit.aspx"],
    ["ViewMachineTypeInfo", "Admin/ManageMachineTypeEdit.aspx"],
    ["ViewMachineTypeResources", "Admin/ManageMachineTypeEdit.aspx"],
    ["ViewMachineTypeModelList", "Admin/ManageMachineTypeEdit.aspx"],
    ["ViewMachineTypeMachineList", "Admin/ManageMachineTypeEdit.aspx"],
    //models
    ["MachineModels", "Admin/ManageMachineModel.aspx"],
    ["NewMachineModel", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModel", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModelInfo", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModelResources", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModelCommonParts", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModelMachineList", "Admin/ManageMachineModelEdit.aspx"],
    ["ViewMachineModelSync", "Admin/ManageMachineModelEdit.aspx"],
    //supplier
    ["Suppliers", "Admin/ManageSupplier.aspx"],
    ["ViewSupplier", "Admin/ManageSupplierEdit.aspx"],
    ["NewSupplier", "Admin/ManageSupplierEdit.aspx"],
    ["ViewSupplierInfo", "Admin/ManageSupplierEdit.aspx"],
    ["ViewSupplierResources", "Admin/ManageSupplierEdit.aspx"],
    ["ViewSupplierFailureCodeList", "Admin/ManageSupplierEdit.aspx"],
    ["ViewSupplierModelList", "Admin/ManageSupplierEdit.aspx"],
    ["ViewSupplierMachineList", "Admin/ManageSupplierEdit.aspx"],
    //articles
    ["Articles", "Admin/ManageArticle.aspx"],
    ["ViewArticle", "Admin/ManageArticleEdit.aspx"],
    ["ViewArticleInfo", "Admin/ManageArticleEdit.aspx"],
    ["ViewArticleResources", "Admin/ManageArticleEdit.aspx"],
    ["ViewArticleRelations", "Admin/ManageArticleEdit.aspx"],
    ["ViewArticleJobCategoryList", "Admin/ManageArticleEdit.aspx"],

    ["Counters", "Admin/ManageCounters.aspx"],
    //["Counters", "Admin/ManageCountersEdit.aspx?id=0"],
    ["ViewCounter", "Admin/ManageCountersEdit.aspx"],
    ["ViewCounterInfo", "Admin/ManageCountersEdit.aspx"],

    ["MyPageHome", "MyPage/MyJobs.aspx"],
    ["SiteSettings", "MyPage/UserAccountEdit.aspx"],
    //jobs
    ["MyJobs", "MyPage/MyJobs.aspx"],
    ["MyCar", "MyPage/ManageMyCarEdit.aspx"],
    ["MyInventory", "MyPage/ManageMyCarEdit.aspx"],
    ["MyPickinglist", "MyPage/ManageMyCarEdit.aspx"],
    ["MyAccount", "MyPage/UserAccountEdit.aspx"],
    ["MyHourlist", "MyPage/TimeReport.aspx"],
    ["JobList", "Job/managejob.aspx"],
    ["JobSubStatusList", "Job/ManageJob.aspx"],
    ["Job", "Job/ManageJob.aspx?landingpage"],
    ["JobList", "Job/managejob.aspx?leftmenuid=0"],
    ["JobList", "Job/managejob.aspx?leftmenuid=-2"],
    ["NewJobStart", "Job/ManageJobEdit.aspx?id=0"],
    ["NewJobOverview", "Job/ManageJobEdit.aspx?id=0"],
    ["ViewJobGeneral", "Job/ManageJobEdit.aspx"],
    ["ViewJobPlanning", "Job/ManageJobEdit.aspx"],
    ["ViewJobLogg", "Job/ManageJobEdit.aspx"],
    ["ViewJobResources", "Job/ManageJobEdit.aspx"],
    ["ViewJobParts", "Job/ManageJobEdit.aspx"],
    ["JobEditPart", "Job/ManageJobEdit.aspx"],
    ["JobEditTime", "Job/ManageJobEdit.aspx"],
    ["JobAddPart", "Job/ManageJobEdit.aspx"],
    ["JobAddTime", "Job/ManageJobEdit.aspx"],
    ["ViewJobOrder", "Job/ManageJobEdit.aspx"],
    ["ViewJobInvoice", "Job/ManageJobEdit.aspx"],

    ["Planner", "Planning/"],

    ["NextOrders", "Contracts/ContractOrder.aspx"],
    ["Contracts", "Contracts"],
    
    ["Dashboard", "DashBoard/DashBoard.aspx"],
    ["DashboardHome", "DashBoard/DashBoard.aspx"],
    ["TimeReport", "DashBoard/TimeReport.aspx"],
    ["Dashboard", "DashBoard/Export.aspx"],
    ["Dashboard", "DashBoard/PMReport.aspx"],
    
    ["Settings", "Admin/ManageSetting.aspx"],
    ["CompanySettings", "Admin/ManageSetting.aspx"],
    ["EmailSettings", "Admin/ManageSetting.aspx"],
    ["EditEmailSetting", "Admin/ManageSetting.aspx"],
    ["DefaultSettings", "Admin/ManageSetting.aspx"],
    ["Features", "Admin/ManageSetting.aspx"],
    ["RepairCodes", "Admin/"],
    ["FailureCodes", "Admin/"],
    ["LeadList", "Admin/"],
    ["LeadTypes", "Admin/"],
    ["LeadEmail", "Admin/"],
    ["Inventory", "Admin/"],
    ["EventLogs", "Admin/"],
    ["MailLogs", "Admin/"],
    ["SmsLogs", "Admin/"],
    ["TaskLogs", "Admin/"],
    ["WarrantyTypes", "Admin/"],
    ["PartnerCompanies", "Admin/"],
    ["ViewPartnerCompanyInfo", "Admin/"],
    ["PartnerCompanyUsers", "Admin/ManageUser.aspx"],
    ["PartnerUsers", "Admin/ManageUser.aspx"],
    ["PartnerEmail", "Admin/"],
    ["RepairPlaces", "Admin/"],
    ["AssetTypes", "Admin/"],
    ["ServiceAgreements", "Admin/"],
    ["ArticleLogs", "Admin/ManageArticleEdit.aspx"],
    ["CustomerLogs", "Admin/ManageCustomerEdit.aspx"],
]);
export default pagemap;